import { cx } from 'class-variance-authority';

const ActionRow: React.FC<{
    children: React.ReactNode;
    className?: string;
}> = props => (
    <div className={cx('md:flex md:h-24 md:items-center', props.className ?? 'md:justify-end')}>
        {props.children}
    </div>
);

export default ActionRow;
